<template>
  <v-app-bar-nav-icon
    @click.stop="$emit('toggle')"
    class="ml-sm-4"
  >
    <v-icon color="white" size="37">menu</v-icon>
  </v-app-bar-nav-icon>
</template>

<script>
export default {
  name: "LeftMenuToggle",
  emits: ['toggle']
}
</script>
